export default function scriptService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    viewField.cols = viewField.cols || engineApi.options.cols || 8; // por defecto el script son 8 cols

    const fbScript = engineApi.field.setCommonAttributes('fb-script', viewField, engineApi);

    if (Array.isArray(viewField.metadata.variables)) {
      fbScript.addAttribute('variables', JSON.stringify(viewField.metadata.variables), true, "'");
    }

    return fbScript;
  };
}
